export const update = {
  updateSuccessfully: 'Update operator successfully!',
}
